import { ReactElement } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAppSelector } from "../hooks/reduxHooks";

interface PropsPrivateRoute {
  children: ReactElement;
}
export const PrivateRoutes = ({ children }: PropsPrivateRoute) => {
  const { status } = useAppSelector((state) => state.auth);
  const { pathname, search } = useLocation();
  const lastPath = pathname + search;
  localStorage.setItem("lastpath", lastPath);

  return status === "authenticated" ? (
    children
  ) : (
    <Navigate to={"/auth/login"} />
  );
};
